import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MediaBankViewComponent } from './media-bank-view/media-bank-view.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { ComponentsModule } from '@fi-app/components/components.module';
import { WidgetModule } from '@fi-app/widget/widget.module';
import { MediaBankEditComponent } from './media-bank-edit/media-bank-edit.component';
import { FormsModule } from '@angular/forms';
import { DocumentModule } from '@fi-app/document/document.module';
import { MediaBankNewComponent } from './media-bank-new/media-bank-new.component';
import { MediaBankService } from './media-bank.service';
import { MediaBankListDataService } from './media-bank-list-data.service';
import { MediaBankConfirmDeleteComponent } from './media-bank-confirm-delete/media-bank-confirm-delete.component';
import { MediaBankConfirmDeleteListItemUsesComponent } from './media-bank-confirm-delete/media-bank-confirm-delete-list-item-uses/media-bank-confirm-delete-list-item-uses.component';
import { MediaBankConfirmDeleteViewRowComponent } from './media-bank-confirm-delete/media-bank-confirm-delete-view-row/media-bank-confirm-delete-view-row.component';
import { FiMediaBankListViewComponent } from './media-bank-list-view/media-bank-list-view.component';
import { FiMediaBankListViewStateComponent } from './media-bank-list-view-state/media-bank-list-view-state.component';
import { MediaBankListContainerComponent } from './media-bank-list-container/media-bank-list-container.component';
import { MediaBankViewContainerComponent } from './media-bank-view-container/media-bank-view-container.component';
import { FiTextItemLinksToPopupOpeners } from '../utilities/text-item-links-to-popup/text-item-links-to-popup.directive';
import { FiEditPublicationModule } from '@fi-shared/fi-edit-publication';
import { FiCommentsSettingsModule } from '@fi-shared/fi-comments/fi-comments-settings';
import { FiLinkToType } from '@fi-shared/fi-text-item-helper/fi-link-to-type';
import { FiVimeoModule } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo.module';
import { FileSizeModule } from '@fi-shared/media-bank/file-size/file-size.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { FiMediaBankFileReferencePreviewModule } from '@fi-shared/fi-media-bank-file-reference-preview/fi-media-bank-file-reference-preview.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiCommentsListModule } from '@fi-shared/fi-comments/fi-comments-list/fi-comments-list.module';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MediaBankNamesDescriptionsComponent } from '@fi-app/media-bank/media-bank-names-descriptions/media-bank-names-descriptions.component';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiPrintDownloadModule } from '@fi-shared/fi-print-download/fi-print-download.module';
import { MatCardModule } from '@angular/material/card';
import { FiPageCollapsableContentModule } from '@fi-app/components/fi-page-collapsable-content/fi-page-collapsable-content.module';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { MediaBankNewListComponent } from '@fi-app/media-bank/media-bank-list-view/media-bank-new-list/media-bank-new-list.component';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiSiteDesignModule } from '@fi-app/fi-site-design/fi-site-design.module';
import { MediaBankPreviewModule } from './media-bank-preview/media-bank-preview.module';
import { FiNameInputModule } from '@fi-app/shared/fi-name-input/fi-name-input.module';

const FiTextItemLinksToPopupOpenersMediaProvider = {
    provide: FiTextItemLinksToPopupOpeners,
    useFactory: (mediaBankService: MediaBankService) => (linkToModel) => {
        if (linkToModel.Type === FiLinkToType.Media) {
            mediaBankService.openMediaViewDialog(linkToModel.Value.Id, {
                showInsert: false,
                showBackButton: false,
                Title: linkToModel.Value.Name,
            });
            return true;
        }
    },
    deps: [MediaBankService],
    multi: true,
};

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatCheckboxModule,
        MatRadioModule,
        UtilitiesModule,
        ComponentsModule,
        WidgetModule,
        DocumentModule,
        FiEditPublicationModule,
        FiCommentsSettingsModule,
        FiVimeoModule,
        FileSizeModule,
        FiPageHeaderButtonGroupModule,
        FiMediaBankFileReferencePreviewModule,
        MatIconModule,
        MatButtonModule,
        FiCommentsListModule,
        FiItemsListModule,
        FiPageHeaderModule,
        MatFormFieldModule,
        MatInputModule,
        SelectSearchModule,
        FiPrintDownloadModule,
        MatCardModule,
        FiPageCollapsableContentModule,
        FiErrorMessageModule,
        FiWrapperTableModule,
        FiLocalSearch2Module,
        FiSiteDesignModule,
        MediaBankPreviewModule,
        FiNameInputModule,
    ],
    declarations: [
        MediaBankViewComponent,
        MediaBankEditComponent,
        MediaBankNewComponent,
        MediaBankConfirmDeleteComponent,
        MediaBankConfirmDeleteListItemUsesComponent,
        MediaBankConfirmDeleteViewRowComponent,
        FiMediaBankListViewComponent,
        FiMediaBankListViewStateComponent,
        MediaBankListContainerComponent,
        MediaBankViewContainerComponent,
        MediaBankNamesDescriptionsComponent,
        MediaBankNewListComponent,
    ],
    exports: [FiMediaBankListViewComponent, MediaBankNewListComponent],
    providers: [MediaBankService, MediaBankListDataService, FiTextItemLinksToPopupOpenersMediaProvider],
})
export class MediaBankModule {}
